import React, { Component } from 'react';
import ApiManager from '../../../apiManager';
// import Loading from '../../Fragments/Loading';
import { trans, setBracketsAfterFirstPart, getFileNameExt } from '../../../helpers';
import Select from 'react-select';
import config from '../../../baseConfig';
import Modal from '../../Fragments/Modal';
import FormMiddlewareError from '../../Fragments/FormMiddlewareError';

class B2bCreateApplication extends Component {

    constructor( props ){
        super( props );

        this.state = {
            appTypeOptions: [],
            appTariffPlanOptions: [],
            commentText: '',
            appTypeSelectedOption: null,
            tariffPlanSelectedOption: null,
            prioritySelectedOption: null,
            uploadFilesProgress: false,
            uploadFilesResponse: '',
            formResponse: '',
            successModal: false
        };

        // Component props
        this.componentIsMounted = true;

        // Bind own methods
        this.createAppSuccess = this.createAppSuccess.bind( this );
        this.getAppTypesSuccess = this.getAppTypesSuccess.bind( this );
        this.getTariffPlanListSuccess = this.getTariffPlanListSuccess.bind( this );

    }

    componentDidMount() {

        // Get types
        this.getAppTypes();

    }

    componentDidUpdate(){

        if ( this.props.isLanguageChanged ) {

            this.setState({
                appTypeSelectedOption: null,
                tariffPlanSelectedOption: null,
                prioritySelectedOption: null
            });

            this.getAppTypes();
            this.getTariffPlanList();

            this.props.updateParentState({
                isLanguageChanged: false
            });

        }

    }

    getTariffPlanList(){

        ApiManager.getRequest({
            jwt: this.props.getDecryptedToken(),
            billing_type: this.props.banSelectedTp
        }, '/application/tariff').then( this.getTariffPlanListSuccess, this.props.errorCallBack );

    }

    getTariffPlanListSuccess({ data }){

        if ( data.status === 'OK' ) {

            this.setState({
                appTariffPlanOptions: data.data.tariffs.map(({ id, name }) => ({ 'label': name, 'value': id }))
            });

        }

    }

    getAppTypes(){

        ApiManager.getRequest({}, '/application/types').then( this.getAppTypesSuccess, this.props.errorCallBack );

    }

    getAppTypesSuccess({ data }){

        if ( !this.componentIsMounted ) {
            return;
        }

        if ( data.status === 'OK' ) {

            const appTypeOptions = [{
                label: trans(this.props.b2bTrans, 'b2b.application.new_tp_title'),
                value: 0
            }];

            for ( var i in data.data.types ) {
                appTypeOptions.push({
                    "label": data.data.types[i]['title'],
                    "value": data.data.types[i]['id']
                });
            }

            this.setState({
                appTypeOptions
            });

        }

    }

    componentWillUnmount(){

        this.componentIsMounted = false;

    }

    drawCtns(){

        const ctns = this.props.applicationData.map(( item, index ) => {
            return (
                <li className="application-form__ctn-item fs18 ver-top-box pr" key={index}>+374 {setBracketsAfterFirstPart(item.toString().replace(/^74/, ''))}
                    <button
                        className="application-form__btn sprite pa"
                        type="button"
                        onClick={() => {

                            const applicationData = this.props.applicationData;

                            applicationData.splice( applicationData.indexOf( item ), 1 );

                            this.props.updateParentState({ applicationData });

                            if ( !applicationData.length ) {
                                this.props.history.goBack();
                            }

                        }}
                    > </button>
                </li>
            );
        });

        return (
            <ul className="application-form__ctn-list scroller-block">{ctns}</ul>
        );

    }

    appPriorityTypeOptions(){

        return [
            { value: 0, label: trans(this.props.b2bTrans, 'b2b.application.priority_0') },
            { value: 1, label: trans(this.props.b2bTrans, 'b2b.application.priority_1') },
            { value: 2, label: trans(this.props.b2bTrans, 'b2b.application.priority_2') },
            { value: 3, label: trans(this.props.b2bTrans, 'b2b.application.priority_3') }
        ];

    }

    attachedFileList(){

        let fileList = '';
        const { uploadFilesResponse } = this.state;

        if ( uploadFilesResponse !== '' && uploadFilesResponse.status === 'OK' ) {

            fileList = uploadFilesResponse.data.map(( { label, file_name }, index ) => {

                const { fileName, fileExt } = getFileNameExt(label);

                return (
                    <li className={`application-form__file-item application-form__file-item--${fileExt} fs18 monserrat-medium ver-top-box pr`} key={index}>{fileName}
                        <button
                            className="application-form__remove sprite pa"
                            type="button"
                            onClick={() => {
                                uploadFilesResponse.data = uploadFilesResponse.data.filter(item => item.file_name !== file_name);
                                this.setState({
                                    uploadFilesResponse
                                });
                            }}
                        ></button>
                    </li>
                );
            });

            fileList = <ul className="application-form__file-list">{fileList}</ul>;

        }

        return fileList;

    }

    uploadFiles( files ){

        this.setState({
            uploadFilesProgress: true
        });

        const data = {};

        for( const i in files ) {

            if ( typeof files[i] === 'object' ) {
                data['files[' + i + ']'] = files[i];
            }

        }

        ApiManager.postRequest( data, '/g-uploader/upload').then(( resolve ) => {

            if ( !this.componentIsMounted ) {
                return;
            }

            this.setState({
                uploadFilesProgress: false,
                uploadFilesResponse: resolve.data
            });

        }, this.props.errorCallBack);

    }

    createAppSuccess( { data } ){

        if ( !this.componentIsMounted ) {
            return;
        }

        this.setState({
            formResponse: data,
            successModal: data.status === 'OK',
            uploadFilesProgress: false
        });

    }

    ctnFileSetter( data ){

        const { uploadFilesResponse } = this.state;

        if ( uploadFilesResponse !== '' && uploadFilesResponse.status === 'OK' ) {
            uploadFilesResponse.data.map(( item, index ) => data['application_file[' + index + ']'] = item.file_name);
        } else {
            data['application_file[0]'] = '';
        }

        this.props.applicationData.map(( item, index ) => data['ctn[' + index + ']'] = item);

    }

    createApp(){

        this.setState({
            uploadFilesProgress: true
        });

        const { appTypeSelectedOption, prioritySelectedOption, commentText, tariffPlanSelectedOption } = this.state;

        const data = {
            _token: this.props.csrf_token.data,
            jwt: this.props.getDecryptedToken(),
            ban: this.props.activeBan,
            application_curator_comments: commentText,
            application_priority: prioritySelectedOption && prioritySelectedOption.value,
            application_type_id: appTypeSelectedOption && appTypeSelectedOption.value
        };

        if ( appTypeSelectedOption && appTypeSelectedOption.value === 0 && tariffPlanSelectedOption ) {
            data['application_tariff_id'] = tariffPlanSelectedOption.value;
        }

        this.ctnFileSetter( data );

        ApiManager.postRequest(data, '/b2bcurator/application/save').then( this.createAppSuccess, this.props.errorCallBack );

    }

    appSuccessModal(){

        if ( !this.state.successModal ) {
            return '';
        }

        return (
            <Modal
                title={trans(this.props.b2bTrans, 'b2b.create_application.success_modal.title')}
                description={trans(this.props.b2bTrans, 'b2b.create_application.success_modal.description')}
                agreeText={trans(this.props.b2bTrans, 'b2b.create_application.success_modal.agree')}
                agreeAction={() => {
                    this.props.history.push( config.urlPrefix + this.props.urlPrefix + '/applications' );
                    this.props.updatePath();
                }}
                className="modal--full"
            />
        );

    }

    changeTypeSelect( appTypeSelectedOption ){

        if ( appTypeSelectedOption.value === 0 && !this.state.appTariffPlanOptions.length ) {
            this.getTariffPlanList();
        }

        this.setState({ appTypeSelectedOption });

    }

    render(){

        const { uploadFilesResponse, formResponse } = this.state;

        let uploadErrorClass = '',
            uploadErrorBox = '',
            typeErrorClass = '',
            typeErrorBox = '',
            priorityErrorClass = '',
            priorityErrorBox = '',
            commentsErrorClass = '',
            commentsErrorBox = '',
            tariffErrorClass = '',
            tariffErrorBox = '',
            errorBox = '';

        if ( uploadFilesResponse !== '' && uploadFilesResponse.status === 'INVALID_DATA' ) {
            uploadErrorClass = ' form-error';
            uploadErrorBox = <div className="form-error-text fs11">{uploadFilesResponse.message}</div>;
        }

        if ( formResponse !== '' && formResponse.status === 'INVALID_DATA' ) {

            if ( formResponse.errors.hasOwnProperty('application_type_id') ) {

                typeErrorClass = ' form-error';
                typeErrorBox = <div className="form-error-text fs11">{formResponse.errors.application_type_id}</div>;

            }

            if ( formResponse.errors.hasOwnProperty('application_tariff_id') ) {

                tariffErrorClass = ' form-error';
                tariffErrorBox = <div className="form-error-text fs11">{formResponse.errors.application_tariff_id}</div>;

            }

            if ( formResponse.errors.hasOwnProperty('application_priority') ) {

                priorityErrorClass = ' form-error';
                priorityErrorBox = <div className="form-error-text fs11">{formResponse.errors.application_priority}</div>;

            }

            if ( formResponse.errors.hasOwnProperty('application_curator_comments') ) {

                commentsErrorClass = ' form-error';
                commentsErrorBox = <div className="form-error-text fs11">{formResponse.errors.application_curator_comments}</div>;

            }

        }

        if ( formResponse !== '' && formResponse.status === 'ERROR' ) {

            errorBox = <FormMiddlewareError message={formResponse.code} />

        }

        return(
            <div className="main-wrapper__right-inner scroller-block pr">
                <div className="main-wrapper__right-content">

                    <h2 className="main-wrapper__title main-wrapper__title--with-border fb fs20">{trans( this.props.b2bTrans, 'b2b.create_app.title' )}</h2>

                    <form className="application-form" action="#" method="post" onSubmit={( event ) => {
                        event.preventDefault();
                        this.createApp();
                    }}>
                        <div className="application-form__box clear-fix">
                            <div className="application-form__label-box fl">
                                <p className="application-form__label fs14">{trans( this.props.b2bTrans, 'b2b.create_app.ban_label' )}</p>
                            </div>
                            <div className="application-form__right-box">
                                <p className="application-form__number monserrat-medium fs18">{this.props.activeBan}</p>
                            </div>
                        </div>
                        <div className="application-form__box clear-fix">
                            <div className="application-form__label-box fl">
                                <p className="application-form__label fs14">{trans( this.props.b2bTrans, 'b2b.create_app.ctn_label' )}</p>
                            </div>
                            <div className="application-form__right-box">
                                <p className="application-form__number application-form__number--bottom-space monserrat-medium fs18">
                                    <b>{this.props.applicationData.length}</b> {trans( this.props.b2bTrans, 'b2b.create_app.ctn_selected_label' )}</p>
                                <div className="application-form__ctn-box ver-top-box">{this.drawCtns()}</div>
                            </div>
                        </div>
                        <div className="application-form__box clear-fix">
                            <div className="application-form__label-box application-form__label-box--top-padding fl">
                                <p className="application-form__label fs14">{trans( this.props.b2bTrans, 'b2b.create_app.app_type_label' )}</p>
                            </div>
                            <div className="application-form__right-box">
                                <div className={`application-form__select-box ver-top-box form__field-out--select-big${typeErrorClass}`}>
                                    <Select
                                        options={this.state.appTypeOptions}
                                        value={this.state.appTypeSelectedOption}
                                        onChange={( appTypeSelectedOption ) => this.changeTypeSelect( appTypeSelectedOption )}
                                        placeholder={trans( this.props.b2bTrans, 'b2b.create_application.select_default_label' )}
                                        noOptionsMessage={() => trans( this.props.b2bTrans, 'b2b.create_application.select_no_options_message' )}
                                    />
                                    {typeErrorBox}
                                </div>
                                {
                                    (this.state.appTypeSelectedOption && this.state.appTypeSelectedOption.value === 0 && this.state.appTariffPlanOptions.length) ?
                                    <div className={`application-form__select-box ver-top-box form__field-out--select-big${tariffErrorClass}`}>
                                        <Select
                                            options={this.state.appTariffPlanOptions}
                                            value={this.state.tariffPlanSelectedOption}
                                            onChange={( tariffPlanSelectedOption ) => this.setState({ tariffPlanSelectedOption })}
                                            placeholder={trans( this.props.b2bTrans, 'b2b.create_application_tariff.select_default_label' )}
                                            noOptionsMessage={() => trans( this.props.b2bTrans, 'b2b.create_application_tariff.select_no_options_message' )}
                                        />
                                        {tariffErrorBox}
                                    </div> : null
                                }
                            </div>
                        </div>
                        <div className="application-form__box clear-fix">
                            <div className="application-form__label-box application-form__label-box--top-padding fl">
                                <p className="application-form__label fs14">{trans( this.props.b2bTrans, 'b2b.create_app.priority_label' )}</p>
                            </div>
                            <div className={`application-form__right-box${priorityErrorClass}`}>
                                <div className="application-form__select-box ver-top-box form__field-out--select-big">
                                    <Select
                                        options={this.appPriorityTypeOptions()}
                                        value={this.state.prioritySelectedOption}
                                        onChange={( prioritySelectedOption ) => this.setState({ prioritySelectedOption })}
                                        placeholder={trans( this.props.b2bTrans, 'b2b.create_application_priority.select_default_label' )}
                                        noOptionsMessage={() => trans( this.props.b2bTrans, 'b2b.create_application_priority.select_no_options_message' )}
                                    />
                                </div>
                                {priorityErrorBox}
                            </div>
                        </div>
                        <div className={`application-form__box clear-fix${commentsErrorClass}`}>
                            <div className="application-form__label-box fl">
                                <label htmlFor="application-comments" className="application-form__label fs14">{trans( this.props.b2bTrans, 'b2b.create_app.comments_label' )}</label>
                            </div>
                            <div className="application-form__right-box">
                                <textarea
                                    className="application-form__textarea"
                                    name="application-comments"
                                    id="application-comments"
                                    cols="30"
                                    rows="10"
                                    value={this.state.commentText}
                                    onChange={( { target } ) => this.setState({ commentText: target.value })}
                                />
                                {commentsErrorBox}
                            </div>
                        </div>
                        <div className="application-form__box clear-fix">
                            <div className="application-form__label-box fl">
                                <label htmlFor="application-file" className="application-form__label fs14">{trans( this.props.b2bTrans, 'b2b.create_app.attach_file_label' )}</label>
                            </div>
                            <div className={`application-form__right-box${uploadErrorClass}`}>
                                <input
                                    type="file"
                                    className="application-form__input-file dn"
                                    id="application-file"
                                    multiple="multiple"
                                    onChange={({ target }) => this.uploadFiles( target.files )}
                                />
                                <div className="application-form__file-box">
                                    <label className="application-form__browse ver-top-box fs18 monserrat-medium sprite-b pr" htmlFor="application-file">{trans( this.props.b2bTrans, 'b2b.create_app.attach_btn_label' )}</label>
                                    <span className="application-form__note fs12 ver-top-box">{trans( this.props.b2bTrans, 'b2b.create_app.attach_note' )}</span>
                                </div>
                                {this.attachedFileList()}
                                {uploadErrorBox}
                            </div>
                        </div>
                        <div className="application-form__box clear-fix mb-none">
                            <div className="application-form__label-box fl">&nbsp;</div>
                            <div className="application-form__right-box">
                                <div>
                                    <div className="ver-top-box">{errorBox}</div>
                                </div>
                                <button
                                    className={`application-form__action-btn btn btn--yellow monserrat-medium fs18 ver-top-box${this.state.uploadFilesProgress ? ' btn--loading' : ''}`}
                                    type="submit"
                                    disabled={this.state.uploadFilesProgress}
                                >{trans( this.props.b2bTrans, 'b2b.create_app.send_btn_title' )}</button>
                                <button
                                    className="application-form__action-btn btn btn--white monserrat-medium fs18 ver-top-box"
                                    type="button"
                                    onClick={() => {
                                        this.props.history.push( config.urlPrefix + this.props.urlPrefix + '/ban/' + this.props.banActiveBan );
                                        this.props.updatePath();
                                        this.props.updateParentState({
                                            banActiveTabIndex: 1
                                        });
                                    }}
                                >{trans( this.props.b2bTrans, 'b2b.create_app.cancel_btn_title' )}</button>
                            </div>
                        </div>
                    </form>

                </div>

                {this.appSuccessModal()}

            </div>
        );

    }

}

export default B2bCreateApplication;